import DonationPage from "../pages/donation";
import DonationStep1Page from "../pages/donation/donation_step1";
import DonationStep2Page from "../pages/donation/donation_step2";
import NotFoundPage from "../pages/error/notFound";
import AppLanding from "../pages/landing/app_landing";
import EventLanding from "../pages/landing/event_landing";
import ProductPage from "../pages/product";
import ProductPaymentResultPage from "../pages/product/product_payment_result";
import ProductStep1Page from "../pages/product/product_step1";
import ProductStep2Page from "../pages/product/product_step2";

const routes = [
  { path: "/", element: <AppLanding /> },
  { path: "/event", element: <EventLanding /> },
  { path: "/donation", element: <DonationPage /> },
  { path: "/product", element: <ProductPage /> },
  { path: "/product_step1", element: <ProductStep1Page /> },
  { path: "/product_step2", element: <ProductStep2Page /> },
  { path: "/donation_step1", element: <DonationStep1Page /> },
  { path: "/donation_step2", element: <DonationStep2Page /> },
  { path: "/product_payment_result", element: <ProductPaymentResultPage /> },

  { path: "*", element: <NotFoundPage /> },
];

export default routes;
